<template>
  <b-container fluid class="pl-0 pr-0">
   <div class="wrapper text-left">
    <div class="row">
      <div class="col-md-4">
        <div>  <h5 class="text-white"><b>Qurbani App Pvt Limited</b> </h5></div>
        <div class="mt-2"> <span class="fa fa-map-marker"> </span> <span style="font-size:14px;">Address : Office 1206,National Science & Technology Park,H-12</span> </div>
        <div class="mt-2"> <span class="fa fa-envelope" > </span> <span style="font-size:14px;">Bakra@qurbaniapp.com </span> </div> 
        <div class="mt-2"> <span class="fa fa-phone"> </span> <span style="font-size:14px;">+92 306 5401886  </span> </div>
      </div>
      <div class="col-md-4">
        <div>  <h5 class="text-white"><b>Top Categories</b> </h5></div>
        <div class="mt-2"> <span style="font-size:14px;"> Cow</span></div> 
        <div class="mt-2"> <span style="font-size:14px;"> Goat </span> </div> 
        <div class="mt-2"> <span style="font-size:14px;"> Sheep </span> </div> 
        <div class="mt-2"> <span style="font-size:14px;"> Sadqah & Aqiqa </span> </div>

      </div>
      <div  :class="['col-md-4',aligners]">
        <div ><span style="font-size:20px;" class="mr-5">Follow us now</span></div>
        <div style="margin-right:3rem">
           <a href="https://www.facebook.com/qurbaniapp8/" target="_blank"><img  class="ml-2 mr-3 mt-3" src="img/facebook-white.png" height="23" width="23" alt="" srcset=""></a> 
            <a href="https://instagram.com/qurbaniapp8?igshid=1dqsslzajj5ym" target="_blank"><img class="ml-2 mr-3 mt-3" src="img/instagram-white.png" height="23" width="23" alt="" srcset=""></a> 
            <a href="https://twitter.com/QurbaniApp" target="_blank"><img class="ml-2 mr-3 mt-3" src="img/twitter-white.png" height="23" width="23" alt="" srcset=""></a> 
        </div>
        <div class="mr-3 mt-2"><span style="font-size:20px;" >Access our app now</span></div>
        <div class="mr-4 mt-1">
            <img  src="img/appstore.png" height="70" width="70" alt="" srcset="">
            <img class="ml-2" src="img/playstore.png" height="70" width="70" alt="" srcset="">
        </div>
                     

        <!-- <div class="row">
          <div class="col-md-12">
            <span class="mr-5">Follow us on</span> 
          </div>
          <div class="col-md-12">
            <a href="https://www.facebook.com/qurbaniapp8/" target="_blank"><img  class="ml-2 mr-3 mt-3" src="img/facebook-white.png" height="30" width="30" alt="" srcset=""></a> 
            <a href="https://instagram.com/qurbaniapp8?igshid=1dqsslzajj5ym" target="_blank"><img class="ml-2 mr-3 mt-3" src="img/instagram-white.png" height="30" width="30" alt="" srcset=""></a> 
            <a href="https://twitter.com/QurbaniApp" target="_blank"><img class="ml-2 mr-3 mt-3" src="img/twitter-white.png" height="30" width="30" alt="" srcset=""></a> 
          </div>
          <div class="col-md-12 mt-2">
            <span class="mr-2">Access our app now</span> 
          </div>
          <div class="col-md-12 mt-3"> 
            <img  src="img/appstore.png" height="70" width="70" alt="" srcset="">
            <img class="ml-2" src="img/playstore.png" height="70" width="70" alt="" srcset="">
          </div>
          
        </div> -->
      </div>
      </div>
    </div>
    </b-container> 
</template>

<script>
export default {
  name:'TopNav',
  computed:{
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    aligners(){
     if(this.isMobile==false) return 'right-aligned'
     else return ''
    }
  }
}
</script>

<style scoped>
@media (max-width: 425px) {
  .wrapper {
    text-align: center !important;
  }
  .wrapper .col-md-3 {
    margin-bottom: 20px !important;
  }
}
.wrapper {
  color: white;
  padding: 10px;
    margin-left: 0px !important;
    margin-right: 0px !important;
    background: #28a745;
    border-top: 0.5px solid rgba(189, 189, 189, 0.637);
    margin-top: 100px;
    /* margin-bottom: 0px; */
    padding-top: 30px;
}
.contact,
.copy,
.copy a {
  font-weight: 600;
  font-size: 12px;
  color: #6a707a !important;
}
.heading {
  font-weight: 500;
  color: white !important;
  margin-bottom: 20px;
}
ul {
  list-style-type: none;
  padding: 0px;
}
ul li a {
  font-size: 12px;
  font-weight: 600;
  color: white !important;
  margin-top: 30px;
}

</style>
